(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bank-account-info', {
                parent: 'entity',
                url: '/bank-account-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.bankAccountInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/bank-account-infos.html',
                        controller: 'BankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('bankAccountType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('bank-account-info-detail', {
                parent: 'entity',
                url: '/bank-account-info/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.bankAccountInfo.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-detail.html',
                        controller: 'BankAccountInfoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('bankAccountType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'BankAccountInfo', function ($stateParams, BankAccountInfo) {
                        return BankAccountInfo.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('bank-account-info.new', {
                parent: 'bank-account-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-dialog.html',
                        controller: 'BankAccountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    ownerTitle: null,
                                    createDate: null,
                                    bankName: null,
                                    accountType: null,
                                    accountNo: null,
                                    cardNo: null,
                                    shabaNo: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('bank-account-info');
                    });
                }]
            })
            .state('bank-account-info.edit', {
                parent: 'bank-account-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-dialog.html',
                        controller: 'BankAccountInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['BankAccountInfo', function (BankAccountInfo) {
                                return BankAccountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('bank-account-info.delete', {
                parent: 'bank-account-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/bank-account-info/bank-account-info-delete-dialog.html',
                        controller: 'BankAccountInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['BankAccountInfo', function (BankAccountInfo) {
                                return BankAccountInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('bank-account-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
